import $ from "jquery";

import "./main.pcss";

$(document).ready(function () {
  window.$("#importantMessageModal").modal("show");
});
